import { render, staticRenderFns } from "./GroupNav.vue?vue&type=template&id=551b845f&scoped=true&"
import script from "./GroupNav.vue?vue&type=script&lang=ts&"
export * from "./GroupNav.vue?vue&type=script&lang=ts&"
import style0 from "./GroupNav.vue?vue&type=style&index=0&id=551b845f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551b845f",
  null
  
)

export default component.exports